// LANDING PAGE URLUTIL
const productionDomains = ['engros.ae', 'engros.ai', 'engros.app', 'engros.at', 'engros.dev', 'engros.es', 'engros.fi', 'engros.in', 'engros.io', 'engros.it', 'engros.nz', 'engros.pt', 'engros.se', 'engros.uk', 'partihandel.io', 'partihandel.se', 'partihanteraren.com', 'pifa.se'];

const getEnvironmentAndDomain = () => {
	const host = window.location.host;

	if (host.includes('pifa.dev')) {
		return {environment: 'sandbox', domain: host};
	}

	if (host.includes('localhost:8080')) {
		return {environment: 'localproduction', domain: host};
	}

	if (host.includes('localhost')) {
		return {environment: 'development', domain: host};
	}

	// Check production domains using endsWith for precise matching
	const matchedDomain = productionDomains.find(domain => host.endsWith(domain));

	if (matchedDomain) {
		// Return the full host (including subdomain) for production
		return {environment: 'production', domain: host};
	}

	return {environment: 'development', domain: 'localhost'};
};

const {environment, domain} = getEnvironmentAndDomain();

const getLoginUrl = () => {
	switch (environment) {
		case 'production':
		case 'sandbox':
			return `https://id.${domain}`;
		case 'localproduction':
			return 'http://id.localhost:8080';
		default:
			return 'http://localhost:2000';
	}
};

const getApiBaseUrl = () => {
	switch (environment) {
		case 'production':
		case 'sandbox':
			return `https://api.${domain}`;
		default:
			return 'http://localhost:8000';
	}
};

export {getLoginUrl, getApiBaseUrl};
